import { Constants } from "@eagerdog/constants";
import {
  IsNotEmpty,
  IsIn,
  IsNumber,
  IsOptional,
  IsString,
  IsBoolean,
} from "class-validator";

import { IBarnHuntScore } from "./barn-hunt-score.interface";

export class BarnHuntScoreDto implements IBarnHuntScore {
  /**
   * Constants.score_result_type:
   * qualified - Pass/Q
   * nq - Fail/NQ
   * absent - Absent
   */
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  /**
   * Time in format MM:SS.00
   * - Instinct: optional, max 1:00
   * - Novice/Open/Senior/Master: required if qualified
   * - Line Drive: required (or "No Time" if DNF)
   * - Crazy 8s: optional, defaults to 2:00
   */
  @IsOptional()
  @IsString()
  time?: string;

  /**
   * Score (Crazy 8s only)
   * Manual point entry
   */
  @IsOptional()
  @IsNumber()
  score?: number;

  /**
   * Time bonus (Crazy 8s only)
   * +5 if time <= 1:45
   * +10 if time <= 1:30
   */
  @IsOptional()
  @IsNumber()
  time_bonus?: number;

  /**
   * REMX flag (Master B only)
   * true if time <= 2:30
   */
  @IsOptional()
  @IsBoolean()
  is_remx?: boolean;

  /**
   * Placement (1st, 2nd, 3rd, 4th, etc.)
   * Calculated based on class rules
   */
  @IsOptional()
  @IsNumber()
  placement?: number;

  /**
   * Height division (for A-level classes)
   * S, M, or L
   */
  @IsOptional()
  @IsString()
  height_division?: string;
}

